const ErrorPage = require('better_error_pages/app');

module.exports = {
  componentDidMount () {
    this.errorPage = new ErrorPage('.error-page-wrapper', this.props.page_type, this.props.template);
    this.errorPage.initialize();
    if (!!this.props.page_code && this.props.has_status_page === 'customer') {
      this.fetch(this.props.page_code, this.props.page_type);
    }
  },

  componentWillReceiveProps (nextProps) {
    if (this.props.page_code != nextProps.page_code) {
      this.fetch(nextProps.page_code, this.props.page_type);
    } else if (nextProps.has_status_page != this.props.has_status_page && nextProps.has_status_page === 'customer' && !!this.props.page_code) {
      this.fetch(this.props.page_code, this.props.page_type);
    }
  },

  fetch (code, type) {
    const url = this.props.hosted_host.replace('hosted', code);
    this.errorPage.fetchStatus(url, type);
  },
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/reveal_mixin.jsx